module.exports = __webpack_public_path__ + "static/game-charecters-3818d8097b5410739e27968683b7889f.png";